const items = [
  "Pâte pétrie le jour même",
  "Cuite à la commande",
  "Pizzaïolo italien",
  "Ingrédients d'origine France & Italie",
  "Sur place ou à emporter",
  "Place Carnot · Mamers",
];

export default function Marquee() {
  return (
    <div
      data-testid="marquee"
      className="bg-[#2d4a22] text-[#f6efe2] py-3 overflow-hidden border-y border-black/10"
      aria-hidden="true"
    >
      <div className="pv-marquee whitespace-nowrap">
        {[...items, ...items, ...items].map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-4 px-8 text-sm sm:text-base uppercase tracking-[0.22em] font-medium"
          >
            <i className="fa-solid fa-pizza-slice text-[#f6c177]" />
            {t}
            <span className="text-[#f6c177]">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
